import { Observable } from 'rxjs';

import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
	LocalStorageEnum,
	LocalStorageService,
} from '@core/services/storage/local-storage.service';

@Injectable()
export class UserTokenInterceptor implements HttpInterceptor {
	constructor(private storage: LocalStorageService) {}

	intercept(
		request: HttpRequest<unknown>,
		next: HttpHandler,
	): Observable<HttpEvent<unknown>> {
		const userToken = this.storage.get(
			LocalStorageEnum.UserToken,
		) as string;
		if (!userToken) return next.handle(request);

		const headersWithToken = request.headers.append(
			LocalStorageEnum.UserToken,
			userToken,
		);
		const reqWithToken = request.clone({ headers: headersWithToken });

		return next.handle(reqWithToken);
	}
}
